import { Component, inject } from '@angular/core';

import { MDTagComponent } from '@melodic-ui/components';
import { AuthenticationService } from '@lb/auth/services/authentication.service';

@Component({
	selector: 'lb-account-issue',
	standalone: true,
	imports: [MDTagComponent],
	templateUrl: 'account-issue.component.html',
	styleUrl: 'account-issue.component.scss'
})
export class AccountIssueComponent {
	private _auth = inject(AuthenticationService);
	claims: any;

	constructor() {
		const token = this._auth.getIDToken();
		if (token) {
			try {
				this.claims = JSON.parse(atob(token.split('.')[1] || ''));
			} catch {}
		}
	}

	logout(): void {
		this._auth.signOut();
	}
}
